import axiosClient from '../axiosClient';
import { ReturnReceptionEndpoints } from '../endpoints/returnReception';
import {
  IOrderReturnSearchParams,
  IReceiveReturnRequest,
  IResolveReturnRequest,
  IReturnIntakeRequest,
} from '../../types/api/request/returnreceptionrequest';
import {
  IGetOrderReturnsResponse,
  IOrderReturn,
  IReturnLookupResponse,
} from '../../types/api/response/returnreceptionresponse';

export const ReturnReceptionService = {
  async list(params: IOrderReturnSearchParams): Promise<IGetOrderReturnsResponse> {
    const res = await axiosClient.get<IGetOrderReturnsResponse>(ReturnReceptionEndpoints.LIST, {
      params,
    });
    return res.data;
  },

  async lookup(code: string): Promise<IReturnLookupResponse> {
    const res = await axiosClient.get<IReturnLookupResponse>(ReturnReceptionEndpoints.LOOKUP, {
      params: { code },
    });
    return res.data;
  },

  async get(returnRef: string): Promise<IOrderReturn> {
    const res = await axiosClient.get<IOrderReturn>(ReturnReceptionEndpoints.GET(returnRef));
    return res.data;
  },

  async receive(returnRef: string, payload: IReceiveReturnRequest): Promise<IOrderReturn> {
    const res = await axiosClient.post<IOrderReturn>(
      ReturnReceptionEndpoints.RECEIVE(returnRef),
      payload,
    );
    return res.data;
  },

  async intake(payload: IReturnIntakeRequest): Promise<IOrderReturn> {
    const res = await axiosClient.post<IOrderReturn>(ReturnReceptionEndpoints.INTAKE, payload);
    return res.data;
  },

  async resendConfirmation(returnRef: string): Promise<IOrderReturn> {
    const res = await axiosClient.post<IOrderReturn>(
      ReturnReceptionEndpoints.RESEND_CONFIRMATION(returnRef),
    );
    return res.data;
  },

  async resolve(returnRef: string, payload: IResolveReturnRequest): Promise<IOrderReturn> {
    const res = await axiosClient.post<IOrderReturn>(
      ReturnReceptionEndpoints.RESOLVE(returnRef),
      payload,
    );
    return res.data;
  },
};
